export default __webpack_public_path__ + "static/media/search.0731fb05.svg";